// import React, { StrictMode } from 'react';
//
// import { RouterProvider } from '@tanstack/react-router';
// import ReactDOM from 'react-dom/client';
// import { I18nextProvider } from 'react-i18next';
//
// import i18n from './i18n/i18n';
// import createRouter from './router';
// import './styles/index.css';
//
// // Create a new router instance
// const router = createRouter();
//
// // Render the app
// const rootElement = document.getElementById('root');
// if (rootElement && !rootElement?.innerHTML) {
//   const root = ReactDOM.createRoot(rootElement);
//   root.render(
//     <StrictMode>
//       <I18nextProvider defaultNS="translation" i18n={i18n}>
//         <RouterProvider router={router} />
//       </I18nextProvider>
//     </StrictMode>,
//   );
// }
import React, { StrictMode } from 'react';

import { RouterClient } from '@tanstack/react-router/ssr/client';
import { hydrateRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import i18n from './i18n/i18n.client';
import createRouter from './router';
import './styles/index.css';

const router = createRouter();

hydrateRoot(
  document, (
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        <RouterClient router={router} />
      </I18nextProvider>
    </StrictMode>),
);
